import type { IconData } from '@stacksjs/iconify-core'

export const textShapes: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m231.359 147l-80.921 205h45.155l15.593-39.5h89.628l15.593 39.5h45.155l-80.921-205Zm-3.594 123.5L256 198.967l28.235 71.533Z\"/><path fill=\"currentColor\" d=\"M384 56H128V16H16v112h40v256H16v112h112v-40h256v40h112V384h-40V128h40V16H384ZM48 96V48h48v48Zm48 368H48v-48h48Zm288-40H128v-40H88V128h40V88h256v40h40v256h-40Zm80-8v48h-48v-48ZM416 48h48v48h-48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default textShapes
